export { default } from '../../v2/signin/signup/index';
